var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as App from '../app';
import { Modal } from '../lib/components';
var CustomModal = /** @class */ (function (_super) {
    __extends(CustomModal, _super);
    function CustomModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.deltaBodyHeight = 250;
        _this.minBodyHeight = 200;
        _this.maxBodyHeight = 450;
        return _this;
    }
    CustomModal.prototype.onResize = function () {
        if (this.body) {
            var height = Math.max(this.minBodyHeight, window.innerHeight - this.deltaBodyHeight);
            height = Math.min(height, this.maxBodyHeight);
            this.body.css('height', "".concat(height, "px"));
        }
    };
    CustomModal.prototype.show = function () {
        _super.prototype.show.call(this);
        this.onResize();
    };
    CustomModal.prototype.draw = function () {
        _super.prototype.draw.call(this);
        this.onResize();
    };
    CustomModal.prototype.onClose = function (data) {
        _super.prototype.onClose.call(this, data);
        App.sounds.click();
    };
    return CustomModal;
}(Modal));
export { CustomModal };
